import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { ModalService } from './services/modal.service';
import { CookieService } from 'ngx-cookie-service';
import { MobileService } from './services/mobile.service';
import { AbTestService } from './services/abtest.service';
import { ModalService2 } from './services/modal2.service';
import { ModalNames } from './modals/v2/Modal';
import { NavController } from '@ionic/angular';
import { ProgressionService } from './services/progression.service';
import { AnalyticsService } from './services/analytics.service';
import { AppDataParserService } from './services/AppDataParser.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    public timeout = null;

    public timer = 300;

    public isWeb = false;

    private subscription: Subscription;

    // CUTOM TIMER
    public maxTimerMinutes = 5.1; // Default = ( 5 minutes - 5 seconds ) 5.1

    public dateNow = new Date();

    public diffDay = new Date(this.dateNow.getTime() + this.maxTimerMinutes * 60000);

    public milliSecondsInASecond = 1000;

    public hoursInADay = 24;

    public minutesInAnHour = 60;

    public SecondsInAMinute = 60;

    public timeDifference = 0;

    public seconds = 0;

    public minutes = 0; 

    public isMobile() {
        return window.innerWidth <= 1098;
    }

    constructor(
        private modal: ModalService,
        private cookieService: CookieService,
        private mobileService: MobileService,
        private abTestService: AbTestService,
        private modalService: ModalService2,
        private navController: NavController,
        private progressionService: ProgressionService,
        private analyticsService: AnalyticsService,
        private appDataParserService: AppDataParserService
    ) {
        this.subscription = interval(1000).subscribe(() => {
            if (localStorage.getItem('startTimer') && localStorage.getItem('startTimer') === '"true"') {
                this.getTimerDifference();
            }
        });
    }

    // Get time difference between two dates
    private async getTimerDifference(): Promise<void> {
        const startDateObj = JSON.parse(localStorage.getItem('startDate'));
        this.timeDifference = new Date(new Date(startDateObj.timestamp).getTime() + this.maxTimerMinutes * 60000).getTime() - new Date().getTime();

        if (this.modalService.isOpenOfType(ModalNames.END_TIME)) return;

        if (this.timeDifference <= 0) {
            const { confirmed } = await this.modalService.open(ModalNames.END_TIME);
            if (confirmed) {
                this.cookieService.set('COMPLETED_EXPERIENCE', 'true');
                localStorage.setItem('startTimer', JSON.stringify('false'));

                this.analyticsService.sendEvent('Experience', 'experience_end');
                this.analyticsService.sendEvent('Experience', 'experience_failed');
                this.analyticsService.sendEvent('Experience', 'experience_last_page', this.progressionService.getCurrentStateName());

                this.mobileService.powerDown();
                this.mobileService.hideMobile();
                
                this.navController.navigateBack([{ outlets: { primary: 'reflection', mobile: null } }]);
            }
            return;
        }

        // Activate every minute
        if (this.timeDifference < (5 * 60000) && this.timeDifference > 1000 && this.timeDifference % 60000 < 1000 && this.timeDifference % 60000 >= 0) {
            this.modalService.open(ModalNames.TIMER);
        }

        this.convertTimeUnit(this.timeDifference);
    }

    // Convert to readable timer units
    private convertTimeUnit(timeDifference: number): void {
        this.seconds = Math.floor(((timeDifference) / (this.milliSecondsInASecond)) % this.SecondsInAMinute);
        this.minutes = Math.floor(((timeDifference) / (this.milliSecondsInASecond * this.minutesInAnHour)) % this.SecondsInAMinute);

        const secondsHTML = this.addZeroToSingularNumber(this.seconds.toString());
        const minutesHTML = this.addZeroToSingularNumber(this.minutes.toString());

        localStorage.setItem('timerHTML', `${minutesHTML}:${secondsHTML}`);
    }

    // Add zero to singular numbers
    addZeroToSingularNumber(n: string): string {
        return (Number(n) < 10) ? `0${n}` : n;
    }

    ngOnInit() {
        this.abTestService.initialize();
        this.appDataParserService.init();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    onDesktopClick() {
        this.mobileService.powerDown();
    }
}
